@if (selectedReport()) {
  <div class="pageHeader">
    <h3 class="pageTitle">Dashboard</h3>
    <button
      mat-stroked-button
      class="ms-auto flex-shrink-0"
      color="primary"
      [disabled]="!loaded"
      (click)="onExportReport()"
    >
      <mat-icon svgIcon="file-export-solid" />
      Export
    </button>
  </div>
}

<app-power-bi-embed
  [selectedReport]="selectedReport()"
  (embeddedReport)="onEmbeddedReportChange($event)"
/>
